import RM360ChatbotView from './RM360ChatbotView';

export default RM360ChatbotView;
